import { useState } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import { Problem, Ecosystem } from "@/components/landing/Manifesto";
import { Offering } from "@/components/landing/Offering";
import { HowItWorks, PricingCalculator, FinalCTA } from "@/components/landing/HowPricing";
import VideoSection from "@/components/landing/VideoSection";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import LeadFormModal from "@/components/LeadFormModal";

export default function Landing() {
  const [leadOpen, setLeadOpen] = useState(false);
  const openLead = () => setLeadOpen(true);

  return (
    <div data-testid="landing-page">
      <Nav onGetStarted={openLead} />
      <Hero onGetStarted={openLead} />
      <EditorialMarquee />
      <Problem />
      <Ecosystem />
      <Offering />
      <VideoSection />
      <HowItWorks />
      <PricingCalculator onGetStarted={openLead} />
      <FinalCTA onGetStarted={openLead} />
      <ContactSection />
      <Footer />
      <LeadFormModal open={leadOpen} onClose={() => setLeadOpen(false)} />
    </div>
  );
}
